<template>
  <div>
    <center>
      <b-tabs style="background-color: transparent !important">
        <b-tab
          :title="'Facture service de' + ' ' + get_societe[0].nom"
          style="margin-top: 31px; background-color: transparent !important"
        >
          <div class="container-fluid" style="height: 65px">
            <div class="text-center" style="margin-top: -33px !important">
              <b-button variant="info" style="font-size: 15px">
                Total
                <b-badge variant="light">{{
                  filteredFactureservices.length
                }}</b-badge>
              </b-button>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <select
                    class="form-control"
                    id="SelectRegion"
                    required
                    @change="facture_service_societe(selectedMois.Month)"
                    v-model="selectedMois.Month"
                  >
                    <option value disabled selected>Mois</option>
                    <option
                      v-for="(annUsers, index) in moezMois"
                      :value="annUsers.id"
                      :key="'i' + index"
                    >
                      {{ annUsers.text }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col">
                <div class="form-group">
                  <select
                    class="form-control"
                    id="SelectRegion"
                    required
                    @change="facture_service_societe(selectedClient.year)"
                    v-model="selectedClient.year"
                  >
                    <option value disabled selected>Année</option>
                    <option
                      v-for="(annUsers, index) in moezAnnee"
                      :value="annUsers.id"
                      :key="'i' + index"
                    >
                      {{ annUsers.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col">
                <div class="form-group">
                  <input
                    class="form-control personalise"
                    placeholder="Recherche ..."
                    type="text"
                    v-model="search"
                  />
                </div>
              </div>
            </div> -->

            <div class="table-responsive" style="border: 1px solid #f5a623">
              <table class="table table-white">
                <thead>
                  <tr>
                    <!--  <th scope="col">#</th> -->

                    <th scope="col">Num F</th>

                    <!-- <th scope="col">Chouffeur</th> -->

                    <th scope="col">Date</th>

                    <th scope="col">Imprimer</th>

                    <th scope="col">Payement</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="user in listes_facture_service"
                    v-bind:key="user.id"
                  >
                    <td>
                     
                      <router-link
        :to="{
          name: 'detaille_service',
          params: { id: user.service.matr },
        }"
      >
                 
              {{ user.num }}
      </router-link>
                    </td>

                    <!-- <td v-text="user.nom_chouffeur"></td> -->

                    <td>{{ user.date }}</td>
                    <td>
                   

                      <a
              
                :href="
                  'https://apil.auto-turki.com/api/dynamic_pdf/pdfLibre/' +
                  user.id
                "
                target="_blank"
                style="background-color: transparent !important"
              >
                <img width="30px" src="imp.png" />
              </a>
                    </td>
                    <b-badge
                      v-if="user.paye == 'Non payé'"
                      style="
                        color: #fff;
                        background-color: #f10735;
                        margin-top: 15px;
                      "
                    >
                      Non payé
                    </b-badge>
                    <b-badge
                      v-else-if="user.paye == 'Payé'"
                      style="
                        color: #fff;
                        background-color: #28e40c;
                        margin-top: 15px;
                      "
                    >
                      Payé
                    </b-badge>
                    <b-badge
                      v-else
                      style="
                        color: #fff;
                        background-color: #f19710;
                        margin-top: 15px;
                      "
                    >
                      En attente
                    </b-badge>
                  </tr>
                </tbody>
              </table>
            </div>
            <CCard
              class="cardLDepDashbord"
              style="
                border: solid 1px #3ec436;
                width: 263px !important;
              "
            >
              <CCardBody>
                <CRow>
                  <div class="col-6">
                    <span style="margin-left: 0px !important" width="30%">
                      <input
                        type="checkbox"
                        @click="select_all_via_check_box"
                        v-model="all_select"
                      />
                      cocher ({{ idsImprimer.length }})
                    </span>
                  </div>
                  <div class="col-2">
                    <span>
                      <a
                        style="color: #333"
                        :href="
                          'https://apil.auto-turki.com/api/pdf_all_service/' +
                          this.idsImprimer
                        "
                        type="button"
                      >
                        <img style="width: 29px" src="imp.png" />
                      </a>
                    </span>
                  </div>
                  <div class="col-2">
                    <img
                    class="pt"
                      style="width: 35px"
                      @click="updatedPaye_all()"
                      src="/icons8-check-64.png"
                    />
                  </div>
                  <div class="col-2">
                    <svg
                    class="pt"

                      @click="updatedENattente_all()"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="50"
                      height="50"
                      viewBox="0 0 172 172"
                      style="fill: #000000; width: 36px;     margin-top: -7px;
    margin-left: -10px;"
                    >
                      <defs>
                        <linearGradient
                          x1="86"
                          y1="8.73438"
                          x2="86"
                          y2="159.25823"
                          gradientUnits="userSpaceOnUse"
                          id="color-1_brp1xIbzY4r5_gr1"
                        >
                          <stop offset="0" stop-color="#d9e021"></stop>
                          <stop offset="1" stop-color="#fb872b"></stop>
                        </linearGradient>
                        <linearGradient
                          x1="19214.24555"
                          y1="1626.34049"
                          x2="19214.24555"
                          y2="28692.29446"
                          gradientUnits="userSpaceOnUse"
                          id="color-2_brp1xIbzY4r5_gr2"
                        >
                          <stop offset="0" stop-color="#d9e021"></stop>
                          <stop offset="1" stop-color="#fb872b"></stop>
                        </linearGradient>
                      </defs>
                      <g
                        fill="none"
                        fill-rule="nonzero"
                        stroke="none"
                        stroke-width="1"
                        stroke-linecap="butt"
                        stroke-linejoin="miter"
                        stroke-miterlimit="10"
                        stroke-dasharray=""
                        stroke-dashoffset="0"
                        font-family="none"
                        font-weight="none"
                        font-size="none"
                        text-anchor="none"
                        style="mix-blend-mode: normal"
                      >
                        <path d="M0,172v-172h172v172z" fill="none"></path>
                        <g>
                          <g>
                            <path
                              d="M86,20.91715c-35.88686,0 -65.08285,29.19599 -65.08285,65.08285c0,35.88686 29.19599,65.08285 65.08285,65.08285c35.88686,0 65.08285,-29.19599 65.08285,-65.08285c0,-35.88686 -29.19599,-65.08285 -65.08285,-65.08285zM86,144.3641c-32.18281,0 -58.3641,-26.18129 -58.3641,-58.3641c0,-32.18281 26.18129,-58.3641 58.3641,-58.3641c32.18281,0 58.3641,26.18129 58.3641,58.3641c0,32.18281 -26.18129,58.3641 -58.3641,58.3641z"
                              fill="url(#color-1_brp1xIbzY4r5_gr1)"
                            ></path>
                            <path
                              d="M112.5572,56.7815c-0.63002,-0.63009 -1.48455,-0.98408 -2.37558,-0.98408c-0.89103,0 -1.74557,0.35399 -2.37558,0.98408l-31.50791,31.50825l-12.10584,-12.09073c-1.31176,-1.31099 -3.43773,-1.31099 -4.74948,0l-9.89202,9.8947c-1.31189,1.31191 -1.31189,3.43892 0,4.75083l24.37428,24.37428c0.63002,0.63009 1.48455,0.98408 2.37558,0.98408c0.89103,0 1.74557,-0.35399 2.37558,-0.98408l43.77299,-43.79382c1.31144,-1.31184 1.31144,-3.43832 0,-4.75016zM76.29913,108.09192l-19.62312,-19.62278l5.14354,-5.14388l12.10618,12.09073c1.31172,1.31077 3.43743,1.31077 4.74915,0l31.50657,-31.50657l5.14287,5.14287z"
                              fill="url(#color-2_brp1xIbzY4r5_gr2)"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                </CRow>
              </CCardBody>
            </CCard>
          </div>
        </b-tab>
      </b-tabs>
    </center>
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";
import _ from "lodash";
export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      /*   selected: [],
      idsImprimer: [],
      select: "",
      all_select: false, */
      /* .................. */
      search: "",
      listes_service: [],
      selected: [],
      get_societe_id_mise: {},
      verif: false,
      selectedOptionId: "",
      moezMois: [
        { id: 1, text: "Janvier" },
        { id: 2, text: "Février" },

        { id: 3, text: "Mars" },
        { id: 4, text: "Avril" },
        { id: 5, text: "Mai" },
        { id: 6, text: "Juin" },

        { id: 7, text: "Juillet" },
        { id: 8, text: "Août" },

        { id: 9, text: "Septembre" },
        { id: 10, text: "Octobre" },
        { id: 11, text: "Novembre" },
        { id: 12, text: "Décembre" },
      ],
      moezAnnee: [
        { id: 2020, text: "2020" },
        { id: 2021, text: "2021" },
        { id: 2022, text: "2022" },

        { id: 2023, text: "2023" },
        { id: 2024, text: "2024" },
        { id: 2025, text: "2025" },
        { id: 2026, text: "2026" },

        { id: 2027, text: "2027" },
        { id: 2028, text: "2028" },
      ],
      anneeUsers: [2020, 2021, 2022, 2024],
      moisUsers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],

      yearSystem: new Date().getFullYear(),
      moisSystem: new Date().getMonth() + 1,
      selectedMois: {
        Month: new Date().getMonth() + 1,
      },

      selectedClient: {
        year: new Date().getFullYear(),
      },
      listes_facture_service: [],
      selected: [],
      q: "",
      /* ************************** */

      idsImprimer: [],
      get_societe: [],
      id_societe: this.$route.params.id,
      select: "",
      all_select: false,
    };
  },

  created() {
    this.infoSociete();

    this.facture_service_societe();
    this.fetchsearch();
    this.get_societe();
  },

  computed: {
    monthDateSystem() {
      if (this.selectedMois.Month < 10) {
        return "0" + this.selectedMois.Month;
      } else {
        return this.selectedMois.Month;
      }
    },
    filteredFactureservices() {
      return this.listes_facture_service;
    },

    filteredservices: function () {
      if (Array.isArray(this.listes_facture_service)) {
        return this.listes_facture_service.filter((pack) => {
          return pack.id.match(this.search) || pack.date.match(this.search);
        });
      }
    },
  },

  methods: {
    keywords() {
      return this.search.split(" ");
    },
    facture_service_societe() {
      axios
        .get(
          `${apiDomain}/api/get_facture_service_societe/${this.$route.params.id}/${this.monthDateSystem}/${this.selectedClient.year}`
        )
        .then((response) => {
          this.listes_facture_service = response.data;
          //this.count_service = response.data.count_service;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    facture_service_societe___() {
      fetch(`${apiDomain}/api/get_facture_okba_paye`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.data;
        })
        .catch((err) => console.log(err));
    },
    fetchsearch() {
      if (this.q.length > 1) {
        axios
          .get(`${apiDomain}/api/get_facture/` + this.q)
          .then((res) => (this.listes_service = res.data))
          .catch((error) => console.log(error));
      } else {
        axios
          .get(`${apiDomain}/api/get_facture`)
          .then((res) => (this.listes_service = res.data))
          .catch((error) => console.log(error));
      }
    },
    searchUnit: _.debounce(function () {
      axios
        .get(`${apiDomain}/api/search_num_fac/` + this.search)
        /*  get('/search_unit?q='+this.search) */
        .then((response) => {
          if (this.search != "") {
            this.listes_service.data = response.data.Fact;
          }
        });
    }),
    infoSociete() {
      axios
        .get(`${apiDomain}/api/get_societe/` + this.id_societe)

        .then((res) => {
          this.get_societe = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    },
    all_imprimer() {
      axios
        .post(
          `${apiDomain}/api/del2/` + this.idsImprimer
        ) /* + this.idsImprimer */
        .then((response) => {
          this.facture_service_societe();
          this.idsImprimer = [];
          this.all_select == true
            ? (this.all_select = false)
            : (this.all_select = true);
        });
    },
    select_all_via_check_box() {
      if (this.all_select == false) {
        this.all_select = true;
        this.listes_facture_service.forEach((user) => {
          this.idsImprimer.push(user.id);
        });
      } else {
        this.all_select = false;
        this.idsImprimer = [];
      }
    },

    updatedPaye_all(id) {
      fetch(`${apiDomain}/api/UpdatedPayement_all/${this.idsImprimer}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.idsImprimer = "";
          this.facture_service_societe();
        })

        .catch((err) => console.log(err));
    },

    updatedPaye(id) {
      fetch(`${apiDomain}/api/UpdatedPayement/${id}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.facture_service_societe();
        })

        .catch((err) => console.log(err));
    },

    updatedENattente_all(id) {
      fetch(
        `${apiDomain}/api/UpdatedPayement_EN_attente_all/${this.idsImprimer}`,
        {
          method: "post",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          this.idsImprimer = "";
          this.facture_service_societe();
        })

        .catch((err) => console.log(err));
    },

    updatedENattente(id) {
      fetch(`${apiDomain}/api/UpdatedPayement_EN_attente/${id}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.facture_service_societe();
        })

        .catch((err) => console.log(err));
    },

    delete_service(id) {
       if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/delete_service/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Service  supprimer avec Succès ! ");

          this.facture_service_societe();
        })

        .catch((err) => console.log(err));
      }
    },
    facture_service_societe____() {
      fetch(`${apiDomain}/api/get_facture`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.all_service;
        })
        .catch((err) => console.log(err));
    },

    getResults(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      let vm = this;
      fetch(`${apiDomain}/api/get_facture?page=` + page)
        .then((res) => res.json())
        .then((data) => {
          this.listes_service = data.all_service;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style>
.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */

.non_paye {
  position: absolute;
  background: #f10735;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /* margin-top: -15.6%; */
  margin-top: 1.4% !important;
  height: 34px;
  line-height: 9px;
  border-radius: 15px;
}

.paye {
  position: absolute;
  background: #28e40c;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  margin-top: -16.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.en_attente {
  position: absolute;
  background: #c37600;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /*   margin-top: -15.6%; */

  margin-top: -16.6% !important;

  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

nav {
  display: flex;
  justify-content: center;
}

.pagination {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.pagination li {
  margin: 0 1px;
  padding: 11px 6px !important;
  text-decoration: none;
}

.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  background-color: #2a357d !important;

  color: #ffffff !important;
  -webkit-box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
  box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
}

.pagination > li > a,
.pagination > li > span {
  color: fff;
  list-style-type: cercle;
  border: 0;
  border-radius: -16px !important;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  padding: 9px;
  margin: 0 3px;
  min-width: 31px;
  height: 31px;
  line-height: 30px;
  color: #999999;
  font-weight: 400;
  font-size: 11px;
  text-transform: uppercase;
  background: transparent;
  /* border-color: blue !important; */
  border-radius: 4px;
  background-color: #e88e08 !important;
  /* border-color: #000; */
  color: #fff !important;
}

.index {
  display: inline-block;
  height: 36px;
  width: 36px;
  line-height: 36px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background-color: #e88e08;
  border-radius: 50% !important;
  text-align: center;
  position: relative;
  z-index: 2;
}

.cer {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: rgb(245 175 19);
}
.cer_green {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: #0ef717;
}
</style>

